import { createContext, useContext, useMemo } from 'react';
import { createRpcClientV2 } from 'rpc-client-utils';

// The following disable directive for no-restricted-imports is intentional.
// We need to import it to default the http client and any access of an http
// client should be done through this context
// eslint-disable-next-line no-restricted-imports
import http from 'hub-http/clients/apiClient';
import { jsx as _jsx } from "react/jsx-runtime";
const RpcClientContext = /*#__PURE__*/createContext('uninitialized');
export function RpcClientContextProvider({
  httpClient,
  children
}) {
  const rpcClient = useMemo(() => createRpcClientV2({
    hubHttpClient: httpClient
  }), [httpClient]);
  const value = useMemo(() => httpClient === http ? null : rpcClient, [httpClient, rpcClient]);
  return /*#__PURE__*/_jsx(RpcClientContext.Provider, {
    value: value,
    children: children
  });
}
export function useCustomRpcClient() {
  const value = useContext(RpcClientContext);
  if (value === 'uninitialized') {
    throw new Error('Must call useCustomRpcClient inside of RpcClientContextProvider');
  }
  return value;
}